<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">合作项目</div>
                <el-select  class="search-item" style="width: 180px;" size="small" v-model="searchData.Projects2" multiple collapse-tags @visible-change="coProjectsVisibleChange($event)">
                    <el-option v-for="item in projectsList" :key="item.ProjectId" :label="item.ProjectName" :value="item.ProjectId"></el-option>
                </el-select>
                <el-button size="small" class="search-btn btn-primary" @click="handleSearch">查询（Enter）</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多查询（F2）</el-button>
                <el-button size="small" icon="fa fa-file-excel-o" class="search-btn btn-primary" @click="exportExcel()">导出Excel</el-button>
                <div style="margin-left: 10px; margin-right: 10px">
                    <el-button v-if="!isDefaultSet" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()"> 打印 </el-button>
                    <el-button v-if="!isDefaultSet" size="small" icon="el-icon-view" class="search-btn btn-primary" @click="printPreview()"> 预览 </el-button>
                    <el-button v-if="isDefaultSet" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="printPreview()">打印</el-button>
                    <el-button v-if="isCanTBSet" size="small" icon="el-icon-setting" type="primary" class="search-btn"
                        @click="showTableSetDialog()">表格设置</el-button>                    
                </div>
            </div>
            <div class="search-ctn-right" v-if="summaryStr">
                <div class="section-summary">
                    <div>
                        <span>{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                border=""
                @selection-change="handleSelectionChange"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; cursor: pointer"
                highlight-current-row
                :row-key="getRowKeys"
                :tableCode="tableCode"
            >
                <el-table-column type="selection" reserve-selection></el-table-column>
                <template v-for="(col, index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-if="col.ColumnCode == 'Total'"
                    >
                        <template slot-scope="scope">
                            {{ (scope.row.Count && scope.row.Price ? scope.row.Count * scope.row.Price : 0).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'TotalProfit'"
                    >
                        <template slot-scope="scope">
                            {{ (scope.row.Count && scope.row.Profit ? (scope.row.Count >= 0 ? scope.row.Count : -scope.row.Count) * scope.row.Profit : 0).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'WarehouseName'"
                    >
                        <template slot-scope="scope">
                            {{ (scope.row.WarehouseName ? scope.row.WarehouseName : '') + (scope.row.WarehouseCode ? ' / ' + scope.row.WarehouseCode : '') }}
                            <span v-if="scope.row.WarehouseType == 1" style="color: #8492a6">(前置仓)</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50, 100, 200]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="出库记录搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-iologs-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item label="汽配编码">
                        <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="汽配编码"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入配件名称"
                            :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.AutoSerise"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入车型"
                            :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合作项目" v-if="isExObj('ProjectName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.Projects2" multiple collapse-tags @visible-change="coProjectsVisibleChange($event)">
                            <el-option v-for="item in projectsList" :key="item.ProjectId" :label="item.ProjectName" :value="item.ProjectId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单据编号">
                        <el-input
                            style="width: 100%"
                            size="small"
                            v-model.trim="searchData.OrderCode"
                            v-filter-special-char="searchData.OrderCode"
                            placeholder="请输入出仓的单据编号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="单据类型">
                        <el-select class="search-item" size="small" v-model="searchData.Type" style="width: 100%">
                            <el-option v-for="item in TypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开单部门" v-if="isExObj('OrgName')">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.OrgId"
                            filterable
                            clearable
                            reserve-keyword
                            @change="getSIdData($event)"
                            @visible-change="orgVisibleChange($event)"
                            placeholder="请选择"
                        >
                            <el-option v-for="optionItem in orgList" :key="optionItem.Id" :data-msg="optionItem" :label="optionItem.Name" :value="optionItem.Id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开单人" v-if="isExObj('StaffName')">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.StaffId"
                            class="search-item"
                            filterable
                            placeholder="请选择"
                            @visible-change="staffVisibleChange($event)"
                        >
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="出库仓库" v-if="isExObj('WarehouseName')">
                        <el-select size="small" style="width: 100%" v-model="searchData.WarehouseId" filterable clearable @visible-change="wHVisibleChange($event)">
                            <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId">
                                <span style="float: left">{{ item.WarehouseName }}</span>
                                <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售来源" v-if="isUseSource && isExObj('CusSourcesName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.CusSources" multiple clearable @visible-change="cusSourceVisibleChange($event)">
                            <el-option v-for="item in cusSourceList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌" v-if="isUseSource && isExObj('Brand')">
                        <el-select v-model="searchData.BrandName2" filterable multiple collapse-tags clearable size="small" style="width: 100%" @visible-change="getGoodsBrand($event)">
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开单时间" v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDateTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交日期" v-if="isExObj('ConfirmTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime3"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate3TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <!--  打印列表弹窗 -->
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printListDialogVisible" width="870px">
            <div class="dialog-content" v-if="printListDialogVisible">
                <printContent
                    @closeDialog="closePrintDialog" 
                    :isDefaultSet="isDefaultSet"
                    :isPreview="isPreview"
                    :isInit="true"
                    :isProject="true"
                    :printData="printData"
                    >
                </printContent>
            </div>
        </el-dialog>
        <!-- 打印列表隐藏内容，用于直接打印 -->
        <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important">
            <printContent
                ref="printListDom"
                @closeDialog="closePrintDialog" 
                :isDefaultSet="isDefaultSet"
                :isPreview="isPreview"
                :isInit="false"
                :printData="printData"
                >
            </printContent>
        </div>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
        <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
            <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
            <span>您也可以打开新的窗口进行其他的操作</span>
        </div>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closetableSetDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closetableSetDialog"></tableSets>
            </div>
        </el-dialog>        
    </div>
</template>
<script>
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import tableSets from '@/components/common/tableSets_v2.vue';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        tableSets
    },
    data() {
        return {
            showExportMsg: false,
            printListDialogVisible: false,
            printIdList: [],
            printData: {},
            isPreview: false,
            isDefaultSet: true,
            dialogVisible: false,
            datetime: [],
            datetime3: [],
            isOnly: false,
            pageTitle: '查看记录',
            loading: false,
            tableData: [],
            orgList: [],
            searchData: {
                APCode: '',
                GoodName: '',
                Projects2:[],
                AutoSerise: '',
                Type: '',
                OrgId: '',
                StaffId: '',
                OrderCode: '',
                WarehouseId: '',
                BrandName2:[]    ,
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                CusSources: [],
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            tableDataLength: 0,
            TypeList: [
                { Text: '全部', Value: '' },
                { Text: '销售订单出仓', Value: '0' },
                { Text: '销售退货入仓', Value: '1' }
            ],
            brandList: [],
            SIdList: [],
            warehouseList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            projectsList: [],
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            isUseSource: false, //是否启用销售开单显示来源
            cusSourceList: [],
            tableCode: 'ProjectsOutTable',
            columnShowSets: [],
            tableSetsVisible:false,
            isCanTBSet:false,
            summaryStr:''       
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.getSetsData();
        this.getPrintComponents();
    },
    methods: {
        getConfigByCodes() {
            let that = this;
            let codes = ['syllqdysz', 'dyyl', 'djmrdtsj', 'xsddly','ygsfkzdylb'];
            let isDefaultToday = false;
            that.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'syllqdysz':
                                that.isDefaultSet = result;
                                break;
                            case 'dyyl': //是否出现预览界面
                                that.isPreview = result;
                                break;
                            case 'djmrdtsj':
                                isDefaultToday = result;
                                break;
                            case 'xsddly': //是否启用销售开单显示来源
                                this.isUseSource = result;
                                break;
                            case 'ygsfkzdylb': //是否可自定义列表
                                this.isCanTBSet = result;
                                break;                                
                        }
                    }
                    if (this.isExObj('ConfirmTime')) {
                        //当前设定的日期时间
                        let d = new Date();
                        let year1, month1, day1;
                        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date1 = new Date(year1, month1, day1, 0);
                        that.datetime3.push(date1);

                        //前一天设定的日期时间
                        let year2, month2, day2;
                        d.setTime(d.getTime());
                        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date2 = new Date(year2, month2, day2, 0);
                        that.datetime3.unshift(date2);

                        that.searchData.CStartDate = date2;
                        that.searchData.CEndDate = date1;
                    } else {
                        if (isDefaultToday) {
                            //当前设定的日期时间
                            let d = new Date();
                            let year1, month1, day1;
                            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                            let date1 = new Date(year1, month1, day1, 0);
                            that.datetime.push(date1);

                            //前一天设定的日期时间
                            let year2, month2, day2;
                            d.setTime(d.getTime());
                            [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                            let date2 = new Date(year2, month2, day2, 0);
                            that.datetime.unshift(date2);

                            that.searchData.StartDate = date2;
                            that.searchData.EndDate = date1;
                        }
                    }
                }
                that.getTableData();
            });
        },
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.dialogVisible = true;
            }
            if (key === 27) {
                if (that.dialogVisible) that.dialogVisible = false;
            }
            if (key === 13) {
                that.handleSearch();
                return;
            }
            //左键
            if (key == 37) {
                if (this.searchData.page > 1) {
                    this.searchData.page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                if (this.searchData.page < Math.ceil(this.tableDataLength / this.searchData.limit)) {
                    this.searchData.page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        //获取中文打印模板
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents(9).then((data) => {
                if (data) {
                    Vue.component("printContent", () => import("@/components/printModels/" + data));
                } else {
                    Vue.component("printContent", () => import("@/components/printModels/printOutRecordList"));
                }
            });
        },
        getSIdData() {
            if (this.searchData.OrgId) {
                this.$util.getSIdListByOrg(this.searchData.OrgId).then(data => {
                    this.SIdList = data;
                });
            }
        },
        resetSearch() {
            this.searchData = {
                Projects2:[],
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                Type: '',
                OrgId: '',
                StaffId: '',
                OrderCode: '',
                WarehouseId: '',
                BrandName2:[],
                StartDate: '',
                EndDate: '',
                CStartDate:'',
                CEndDate:'',
                CusSources: [],
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            };
            this.datetime = [];
            this.datetime3 = [];
        },
        // 获取数据
        getTableData() {
            let that = this;
            that.$refs.multipleTable.clearSelection();
            that.$util
                .axiosPost({
                    url: '/api/EntpWarehouse/GetProjectOutRecords',
                    data: that.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (res.errcode != 201) {
                        if (!data) {
                            that.tableData = [];
                            if (that.searchData.page == 1) {
                                that.summaryStr = '';
                            }
                            that.tableDataLength = res.count;
                            return;
                        } else {
                            if (that.searchData.page == 1) {
                                that.summaryStr = data.SummaryStr;
                            }
                            that.tableData = data.DataList;
                            that.tableDataLength = res.count;
                        }
                    }
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;

            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        // 获取仓库列表
        getWarehouse() {
            if (this.WarehouseList.length <= 1) {
                this.$util.getWarehouse(1).then(data => {
                    this.WarehouseList = data;
                });
            }
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(() => {});
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            this.dialogVisible = true;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        coProjectsVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.projectsList.length == 0) that.getCoProjects();
            }
        },
        //  合作项目
        getCoProjects() {
            this.$util.getAuthCoProjects().then(data => {
                this.projectsList = data;
            });
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgList.length <= 1)
                    that.$util.getParentOrgs().then(data => {
                        that.orgList = data;
                    });
            }
        },
        async staffVisibleChange(event) {
            let that = this;
            if (event) {
                if(that.SIdList.length == 0){
                    await  that.$util.getSIdList().then(data => {
                        that.SIdList = data;
                    });
                }
            }
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouseNotAuth(1).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        handleSelectionChange(val) {
            this.printData = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].RId);
            }
            this.printIdList = idList;
        },
        getRowKeys(row) {
            return row.RId;
        },
        exportExcel() {
            let that = this;
            if (that.printIdList.length == 0) {
                that.$confirm('未选择导出明细，是否将筛选结果全部导出？如果数据过多可能耗时稍长', '提醒', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        that.exportData();
                    })
                    .catch(() => {
                        return;
                    });
            } else {
                let ids = this.printIdList;
                this.$util.exportFile_post({
                    url: '/api/EntpWarehouse/ExportProjectOutRecords_V1',
                    data: { Ids: ids }
                });
            }
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选记录');
                return;
            }
            that.saveLoading = true;
            //每次取100条数据
            let saveLimit = 2000;
            //   if(that.tableDataLength>20000)
            //     saveLimit=20000;
            //   else
            //     saveLimit=that.tableDataLength;

            let reqData = { ...that.searchData };
            reqData.limit = saveLimit;
            reqData.Page = that.currtPage;
            reqData.ProjectsType = 0;

            that.$util
                .axiosPost({
                    url: '/api/EntpWarehouse/GetProjectOutRecordsToExport',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    that.saveCount += saveLimit;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.tableDataLength);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.tableDataLength <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile({
                                url: '/api/EntpWarehouse/ExportProject_OutRecords_V1'
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            });
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.saveLoading = false;
                });
        },

        closePrintDialog() {
            this.printListDialogVisible = false;
        },
        // 打印预览
        printPreview() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }
            if (this.printIdList.length == 0) {
                this.$util.warningMsg('请选择出库明细进行打印');
                return;
            }
            this.printListDialogVisible = true;
        },
        print() {
            if (this.printIdList.length == 0) {
                this.$util.warningMsg('请选择出库明细进行打印');
                return;
            }
            this.$refs.printListDom.init(true);
        },
        cusSourceVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusSourceList.length == 0) {
                    that.$util.getSalesOrderSources().then(data => {
                        if (data) {
                            that.cusSourceList = [...data, { Value: '-1', Text: '其他' }];
                        } else {
                            that.cusSourceList = [{ Value: '-1', Text: '其他' }];
                        }
                    });
                }
            }
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
            this.getConfigByCodes();
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },        
        closetableSetDialog(isEdit) {
            this.tableSetsVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },        
    }
};
</script>
<style lang="less" scoped>
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 65vh;
    left: 60vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
</style>
<style lang="less">
#search-iologs-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
